<template>
    <div>
         <ThatsTable title="UPC Generator" ref="table" :multipleSelection="false" :endpoint="endpoint" :columns="columns" :newBtn="true" @open="openNewModal" @row-click="rowClick" :key="tableKey" :filterFormData="filterForm" @clearFilterForm="clearFilterForm" @onSearchTerm="onSearchTerm">  
        </ThatsTable>
        <PageForm ref="pageForm" @success="refreshTable"></PageForm>
    </div>
</template>
<script>
/* eslint-disable no-unused-vars */

import { mapGetters, mapMutations,mapActions } from 'vuex';
import ThatsTable from './PageTable'
import PageForm from './PageForm.vue'

export default {
        components:{
        ThatsTable,
        PageForm,
    },
    inject : [],
    provide(){
        return {
        }
    },
    data(){
        return {
            endpoint : 'upc-generator',
            tableKey : 0,
            filterForm : {
                searchTerm : null,
            },
            
        }
    },


    created(){

      const self = this;
 
    },

    mounted(){
        const self = this;

        // console.log("onmounted")
        this.$eventBus.$on('reloadTable',function(){
            self.tableKey++
            self.setFilters();
        })
    },
    methods: {

       ...mapActions('UpcGeneratorModule',['checkItemUpcCode']),
       ...mapMutations('UpcGeneratorModule',['setFormStatusUpdate','setFormStatusCreate','setEmptyForm','setFilters']),

        rowClick(row){
           
        },
        openNewModal(){
            this.$refs.pageForm.openDialog()
        },
        refreshTable(){
            // //alert(1)
            this.tableKey++
            this.$refs.table.refreshTable()
           
        },

        clearFilterForm(){
            this.filterForm = JSON.parse(JSON.stringify(
                {
                    searchTerm : null,
                }
            ))
        },

        onSearchTerm(searchTerm){
            this.filterForm.searchTerm = searchTerm
        }


      
    },
    computed: {
        ...mapGetters('UpcGeneratorModule',['getLoading', 'columns','initialForm']),       
    },
}


</script>